import React, { useState } from 'react';
import ChatBot from 'react-simple-chatbot';
import CloseIcon from '@mui/icons-material/Close';
import "./chatboxindex.scss"
import { useNavigate } from 'react-router-dom';
const ChatBotIndex = () => {
    const history = useNavigate()
    const [chatbotOpen, setChatbotOpen] = useState(false);

    const toggleChatbot = () => {
        setChatbotOpen(!chatbotOpen);
    };
    const handleNavigateLogin = (item) => {
        if (item == "find-project") {
            history("/all-project-posted")
        }
        if (item == "find-job") {
            history("/hire-talent")
        }
    }


    const steps = [
        {
            id: '1',
            message: 'Hi, Welcome to Nearby Freelancer. How may I help you?',
            trigger: '2',
        },
        {
            id: '2',
            message: 'Are you a freelancer or a recruiter?',
            trigger: 'userType',
        },
        {
            id: 'userType',
            options: [
                { value: 'freelancer', label: 'Freelancer', trigger: 'freelancer' },
                { value: 'recruiter', label: 'Recruiter', trigger: 'recruiter' },
            ],
        },
        {
            id: 'freelancer',
            message: 'Great! Click the link below to log in.',
            trigger: 'freelancerLink',
        },
        {
            id: 'freelancerLink',
            component: (
                <div>
                    <a href="/register-as-freelancer" rel="noopener noreferrer">Freelancer Login Here</a>
                </div>
            ),
            trigger: 'freelancerQuery',
        },
        {
            id: 'freelancerQuery',
            message: 'Please log in to place your query.',
            end: true,
        },
        {
            id: 'recruiter',
            message: 'Great! Click the link below to log in.',
            trigger: 'recruiterLink',
        },
        {
            id: 'recruiterLink',
            component: (
                <div>
                    <a href="/job-recuiter-login" rel="noopener noreferrer">Recruiter Login Here</a>
                </div>
            ),
            trigger: 'recruiterQuery',
        },
        {
            id: 'recruiterQuery',
            message: 'Please log in to place your query.',
            end: true,
        },
    ];




    return (
        <>
            <div className="chatbot-container">
                <div className={`chatbox-home-section  `}>
                    <div className={chatbotOpen ? 'chatbot-open-container' : 'chatbot-inner-section'} >
                        {!chatbotOpen && (
                            <>
                                <div className="login-home-hire-freelancer">
                                    <button onClick={() => handleNavigateLogin("find-project")} >Find Project</button>
                                    <button onClick={() => handleNavigateLogin("find-job")}>Find Jobs</button>
                                </div>

                                <div onClick={toggleChatbot} className='headshot-chatbot'>
                                    <img src="/svg/helpsupport.svg" alt="" />
                                    Help
                                </div>
                            </>


                        )}
                        {chatbotOpen && (
                            <div className="chatbot-open-section">
                                <div className="chatbox-icon">
                                    <CloseIcon onClick={toggleChatbot} />

                                </div>

                                <ChatBot
                                    steps={steps}
                                    // botAvatar={customBotAvatar}
                                    opened={true}
                                    toggleFloating={() => { }}
                                    headerTitle="NBF Support"

                                    headerComponent={<div style={{ backgroundColor: 'black', color: 'white', padding: '15px', textAlign: "center", borderRadius: "32px" }}>NBF Support</div>}
                                    contentStyle={{ boxShadow: "none" }}
                                    bubbleStyle={{ background: 'red', color: 'white' }}
                                    userBubbleStyle={{ background: 'green', color: 'white' }}
                                    bubbleOptionStyle={{ background: 'red', color: 'white' }}

                                />

                            </div>

                        )}
                    </div>




                </div>

            </div>








        </>

    );
};

export default ChatBotIndex;
